import { css, keyframes } from '@emotion/core'

const shimmer = keyframes`
  0% {
    opacity: 0.45;
  }

  50% {
    opacity: 0.8;
  }

  100% {
    opacity: 0.45;
  }
`

export const stateWrapper = css`
  display: flex;
  min-height: 240px;
  padding: 32px 24px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.02);
  text-align: center;
`

export const skeletonWrapper = css`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px 16px 20px;
`

export const skeletonRow = (columnCount) => css`
  display: grid;
  grid-template-columns: repeat(${columnCount}, minmax(0, 1fr));
  gap: 12px;
`

export const skeletonCell = css`
  height: 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  animation: ${shimmer} 1.4s ease-in-out infinite;
`

export const skeletonCellPrimary = css`
  height: 20px;
  background: rgba(255, 255, 255, 0.14);
`
